// src/components/FAQ.js
import React from 'react';

const faqs = [
  {
    question: "How does Oolook's AI create content?",
    answer: "Our AI is trained on a vast dataset of high-performing social media content. You provide a prompt, and it generates on-brand, engaging posts, captions, and hashtags tailored to your selected platform and audience."
  },
  {
    question: "Can I connect multiple social media accounts?",
    answer: "Yes! Our plans are designed to scale with you. The Free plan includes 1 brand, while our paid plans allow you to connect multiple brands and all their associated social profiles."
  },
  {
    question: "Is my data secure with Oolook?",
    answer: "Absolutely. We use industry-standard encryption for data in transit and at rest. Your content and data are yours, and we are committed to keeping them private and secure."
  },
  {
    question: "What if I need more features than the Pro plan offers?",
    answer: "Our Enterprise plan is fully customizable to meet the needs of large teams and agencies. This includes unlimited brands, custom integrations, and a dedicated account manager. Contact our sales team to learn more."
  }
];

const FAQ = () => {
  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-4xl px-6 lg:px-8">
        <h2 className="text-center text-3xl font-bold tracking-tight text-dark-text-primary sm:text-4xl">
          Frequently Asked Questions
        </h2>
        <dl className="mt-16 space-y-8">
          {faqs.map((faq) => (
            <div key={faq.question} className="pt-8 border-t border-white/10">
              <dt className="text-lg font-semibold text-dark-text-primary">{faq.question}</dt>
              <dd className="mt-2 text-base text-dark-text-secondary">{faq.answer}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
};

export default FAQ;